var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 23.997,
    viewBox: "0 0 26.973 23.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(-18.909 -11.772)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      background: "#C8232C"
    },
    id: "heart",
    d: "M13.486,24a1.582,1.582,0,0,1-1.043-.392c-1.09-.953-2.14-1.848-3.067-2.638l0,0a57.043,57.043,0,0,1-6.7-6.286A10.039,10.039,0,0,1,0,8.106,8.43,8.43,0,0,1,2.14,2.348,7.253,7.253,0,0,1,7.535,0a6.785,6.785,0,0,1,4.238,1.463,8.671,8.671,0,0,1,1.713,1.789A8.671,8.671,0,0,1,15.2,1.463,6.785,6.785,0,0,1,19.438,0a7.253,7.253,0,0,1,5.4,2.348,8.43,8.43,0,0,1,2.14,5.758A10.038,10.038,0,0,1,24.3,14.678a57.03,57.03,0,0,1-6.7,6.285c-.929.791-1.981,1.688-3.073,2.643A1.583,1.583,0,0,1,13.486,24ZM7.535,1.58A5.69,5.69,0,0,0,3.3,3.419,6.858,6.858,0,0,0,1.58,8.106,8.447,8.447,0,0,0,3.892,13.67a56.133,56.133,0,0,0,6.5,6.091l0,0c.93.793,1.985,1.692,3.083,2.652,1.1-.962,2.161-1.862,3.093-2.656a56.143,56.143,0,0,0,6.5-6.091,8.448,8.448,0,0,0,2.312-5.563,6.858,6.858,0,0,0-1.721-4.687A5.69,5.69,0,0,0,19.438,1.58a5.24,5.24,0,0,0-3.272,1.133,7.667,7.667,0,0,0-1.823,2.11,1,1,0,0,1-1.713,0,7.66,7.66,0,0,0-1.823-2.11A5.24,5.24,0,0,0,7.535,1.58Zm0,0",
    transform: "translate(18.909 11.772)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/likeIcon.b2329dd446e005411d649c83fd29863f.svg";
export { ForwardRef as ReactComponent };